// Single source of truth for an integration's connection status across every surface
// (Settings > Integrations, the campaign Integrations tab, and the Sales Account page).
// Driven by the universal `connectionStatus` field (active | needs_reconnect) + legacy Gmail OAuth.

export const getConnectionState = (integration) => {
  // `connectionType === 'oauth'` only exists for legacy Gmail accounts that must migrate to App Password.
  const needsReconnect = integration?.['connectionStatus'] === 'needs_reconnect'
    || integration?.['connectionType'] === 'oauth';
  return {
    needsReconnect,
    label: needsReconnect ? 'Needs reconnect' : 'Active',
    tone: needsReconnect ? 'error' : 'ok',
    title: needsReconnect ? (integration?.['connectionError'] || 'Reconnect required') : 'Connected',
  };
};
